import { PropertyType } from '../../../common';

const mapEntities = (entities: PropertyType[]) => entities.map((e) => e.value);

export const mapEntityToApi = (data: PropertyType): PropertyType => {
	const apiData: PropertyType = {
		sid: data.token,
		uid: data.userId,
	};

	if (data.username) apiData.name = data.username;
	if (data.email) apiData.email = data.email;
	if (data.activePartners) apiData.partners = mapEntities(data.activePartners);
	if (data.activeCurrency) apiData.currency = data.activeCurrency[0].value;
	if (data.activeLanguage) apiData.lang_id = data.activeLanguage[0].value;
	if (data.activeDateTime) apiData.date_format = data.activeDateTime[0].value;
	if (data.activeRoles) apiData.roles = mapEntities(data.activeRoles);
	if (data.activePermissions) apiData.changeProperties = data.activePermissions;

	return apiData;
};
